/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Tutoriumstitle1Inputs */

const en__field_tutoriumstitle1 = /** @type {(inputs: _Field_Tutoriumstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorium title`)
};

const de__field_tutoriumstitle1 = /** @type {(inputs: _Field_Tutoriumstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutoriums Titel`)
};

/**
* | output |
* | --- |
* | "Tutorium title" |
*
* @param {_Field_Tutoriumstitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_tutoriumstitle1 = /** @type {((inputs?: _Field_Tutoriumstitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Tutoriumstitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_tutoriumstitle1(inputs)
	return de__field_tutoriumstitle1(inputs)
});
export { _field_tutoriumstitle1 as "_field_tutoriumsTitle" }